/// <reference types="react-dom" />
import React = require("react");
import ReactDOM = require("react-dom");
import Component_Base = require("VSS/Flux/Component");
import Preview_Button = require("VSSPreview/Flux/Components/Button");

import Locations = require("VSS/Locations");
import VSS = require("VSS/VSS");
import Navigation_Services = require("VSS/Navigation/Services");
import { LibraryActionCreator } from "DistributedTask/Scripts/Actions/LibraryActionCreator";
import { ErrorMessageBar } from "DistributedTask/Scripts/Components/ErrorMessageBar";
import { LibraryItemMenu } from "DistributedTask/Scripts/Components/LibraryHubMenu";
import { Props as TitleBarProps } from "DistributedTask/Scripts/Components/TitleBar";
import { LibraryItem } from "DistributedTask/Scripts/DT.LibraryItem.Model";
import { LibraryItemType } from "DistributedTask/Scripts/DT.Types";
import { LibraryItemsStore } from "DistributedTask/Scripts/Stores/LibraryItemsStore";
import { Spinner, SpinnerType } from "OfficeFabric/Spinner";
import { announce } from "VSS/Utils/Accessibility";
import Utils_Date = require("VSS/Utils/Date");
import Utils_String = require("VSS/Utils/String");
import Events_Services = require("VSS/Events/Services");

import Constants = require("DistributedTask/Scripts/Constants");
import Dialogs = require("DistributedTask/Scripts/Components/Dialogs");
import Resources = require("DistributedTask/Scripts/Resources/TFS.Resources.DistributedTask");

import { PerfTelemetryManager, TelemetryScenarios } from "DistributedTask/Scripts/Utils/TelemetryUtils";
import { focusDetailsListRow } from "DistributedTaskControls/Common/ReactFocus";
import { StoreManager } from "DistributedTaskControls/Common/Stores/StoreManager";

import { CheckIssueType } from "Checks/Client/Contracts/PipelinesChecks";
import { ObservableValue } from "VSS/Core/Observable";
import { HeaderTitle, HeaderTitleRow } from "VSSUI/Header";
import { HeaderCommandBar, IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { Icon } from "VSSUI/Icon";
import { IMenuItem } from "VSSUI/Menu";
import { Observer } from "VSSUI/Observer";
import { Page } from "VSSUI/Page";
import { ColumnMore, ITableColumn, ITableRow, SimpleTableCell, Table, TableHeaderCell } from "VSSUI/Table";
import { Tab, TabBar, TabContent } from "VSSUI/Tabs";
import { InlineKeywordFilterBarItem } from "VSSUI/TextFilterBarItem";
import { Tooltip } from "VSSUI/TooltipEx";
import { FILTER_CHANGE_EVENT, Filter, IFilterState } from "VSSUI/Utilities/Filter";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import DeleteDialog from "./DeleteDialog";

export interface LibraryItemsTabState extends Component_Base.State {
    selectedTab: number;
    showVariableGroupDeleteDialog: boolean
    showSecureFileDeleteDialog: boolean
    itemsViewState: LibraryItemsViewState[];
}

export interface LibraryItemsViewState extends Component_Base.State {
    data: LibraryItem[];
    searchValue?: string;
    isSortedDescending: boolean;
    errorMessage: string;
}

export class LibraryItemsView extends Component_Base.Component<Component_Base.Props, LibraryItemsTabState> {
    constructor(props: Component_Base.Props) {
        super(props);
        this._filter = new Filter();
        PerfTelemetryManager.initialize();
        PerfTelemetryManager.instance.startTTIScenarioOrNormalScenario(TelemetryScenarios.LibraryLanding);

        // setup state for each tab in the library
        this._store = StoreManager.GetStore<LibraryItemsStore>(LibraryItemsStore);
        let itemsViewState = [];
        itemsViewState.push({ data: null, isSortedDescending: false, errorMessage: "", searchValue: "" });
        itemsViewState.push({ data: null, isSortedDescending: false, errorMessage: "", searchValue: "" });

        // find selected tab and populate data for that tab only
        let selectedTab = LibraryItemType.VariableGroup;
        let urlState = Navigation_Services.getHistoryService().getCurrentState();
        if (urlState.itemType === Constants.LibraryConstants.LibraryItemsView_SecureFiles) {
            selectedTab = LibraryItemType.SecureFile;
        }

        itemsViewState[selectedTab].data = this._store.getData(selectedTab);
        this.state = { selectedTab: selectedTab, itemsViewState, showVariableGroupDeleteDialog: false, showSecureFileDeleteDialog: false };
        this._eventManager = Events_Services.getService();
        if (itemsViewState[selectedTab].data) {
            this._resourcesProvider = new ArrayItemProvider<LibraryItem>(itemsViewState[selectedTab].data);
        }
        this.selectedTabId = selectedTab === LibraryItemType.VariableGroup ? this._variableGroupsKey : this._secureFilesKey;
    }

    public render(): JSX.Element {
        return (
            <Page className="flex-column absolute-fill lib-container">
                <ErrorMessageBar
                    errorMessage={this.state.itemsViewState[this.state.selectedTab].errorMessage}
                />
                <HeaderTitleRow>
                    <div className="flex-row flex-baseline scroll-hidden">
                        <HeaderTitle className="text-ellipsis">
                            {this._getLibraryHubTitle()}
                        </HeaderTitle>
                    </div>
                </HeaderTitleRow>

                <div className="lib-parent">
                    <div className="lib-all-tabs">
                        <div className="lib-tabbars">
                            <TabBar
                                tabsClassName="bolt-card-white"
                                onSelectedTabChanged={this.onSelectedTabChanged}
                                selectedTabId={this.selectedTabId}
                            >
                                <Tab name={Resources.VariableGroupsTabTitle} id={this._variableGroupsKey} />
                                <Tab name={Resources.SecureFilesTabTitle} id={this._secureFilesKey} />
                            </TabBar>
                        </div>
                        <div className="lib-separator-vertical"></div>
                        <div className="lib-commandbars">
                            <HeaderCommandBar className="justify-center lib-header-commandbar" items={this._getCommandBarItemsFor(this.state.selectedTab)} />
                        </div>
                    </div>
                    <div className="lib-filterbars">
                        <InlineKeywordFilterBarItem
                            filter={this._filter}
                            placeholder={this.getSearchBoxLabel()}
                            filterItemKey={this._nameFilterKey}
                            className="lib-inline-filterbar"
                        />
                    </div>
                </div>
                <div className="lib-separator-horizontal"></div>
                <div className="lib-tabcontent">
                    <TabContent>
                        {this.state.selectedTab === LibraryItemType.VariableGroup &&
                            this.getHubContent(LibraryItemType.VariableGroup)
                        }
                        {this.state.selectedTab === LibraryItemType.SecureFile &&
                            this.getHubContent(LibraryItemType.SecureFile)
                        }
                    </TabContent>
                </div>
                {this.renderVariableGroupDeleteDialog()}
                {this.renderSecureFileDeleteDialog()}
            </Page>)
    }

    private renderVariableGroupDeleteDialog(): React.ReactNode {
        let dialog = DeleteDialog.renderVariableGroupsDeleteDialog(this.itemID, this.updateShowVariableGroupsDeleteDialogValue);
        return (
            <Observer isDialogOpen={this.state.showVariableGroupDeleteDialog}>
                {
                    (props: { isDialogOpen: boolean }) => {
                        return props.isDialogOpen ?
                            (
                                dialog
                            )
                            : null;
                    }
                }
            </Observer>
        );
    }

    private renderSecureFileDeleteDialog(): React.ReactNode {
        let dialog = DeleteDialog.renderSecureFilesDeleteDialog(this.itemID, this.updateShowSecureFilesDeleteDialogValue);
        return (
            <Observer isDialogOpen={this.state.showSecureFileDeleteDialog}>
                {
                    (props: { isDialogOpen: boolean }) => {
                        return props.isDialogOpen ?
                            (
                                dialog
                            )
                            : null;
                    }
                }
            </Observer>
        );
    }

    private _getLibraryHubTitle(): React.ReactNode {
        return (
            <div className="flex-row">
                <span className="lib-title">{Resources.LibraryHubTitle}</span>
            </div>
        );
    }

    private onSelectedTabChanged = (newTabId: string) => {
        let state = this.getState();
        if (newTabId === this._variableGroupsKey) {
            state.selectedTab = LibraryItemType.VariableGroup;
            this.selectedTabId = this._variableGroupsKey;
        } else if (newTabId === this._secureFilesKey) {
            state.selectedTab = LibraryItemType.SecureFile;
            this.selectedTabId = this._secureFilesKey;
        }
        this._filter.reset();
        let itemsViewState = state.itemsViewState.slice();
        let storeData = this._store.getData(state.selectedTab);
        let filteredData = storeData ? storeData.filter(i => i.name.toLowerCase().indexOf(state.itemsViewState[state.selectedTab].searchValue.toLowerCase()) > -1) : storeData;
        let sortedData = filteredData ? LibraryItemsView.sortItems(filteredData, "name", state.itemsViewState[state.selectedTab].isSortedDescending) : filteredData;
        itemsViewState[state.selectedTab].data = sortedData;
        if (state.itemsViewState[state.selectedTab].data) {
            this._resourcesProvider = new ArrayItemProvider<LibraryItem>(state.itemsViewState[state.selectedTab].data);
        }
        this.setState(state);
        this.updateUrl();
    }

    private updateUrl() {
        let urlState = Navigation_Services.getHistoryService().getCurrentState();
        let state = this.getState();
        if (state.selectedTab === LibraryItemType.VariableGroup && urlState.itemType !== Constants.LibraryConstants.LibraryItemsView_VariableGroups) {
            urlState.itemType = Constants.LibraryConstants.LibraryItemsView_VariableGroups;
            Navigation_Services.getHistoryService().replaceHistoryPoint(undefined, urlState);
        }
        if (state.selectedTab === LibraryItemType.SecureFile && urlState.itemType !== Constants.LibraryConstants.LibraryItemsView_SecureFiles) {
            urlState.itemType = Constants.LibraryConstants.LibraryItemsView_SecureFiles;
            Navigation_Services.getHistoryService().replaceHistoryPoint(undefined, urlState);
        }
    }

    public componentDidMount() {
        this._store.addChangedListener(this.onStoreChange);
        this._filter.subscribe(this._onFilterChanged, FILTER_CHANGE_EVENT);
        LibraryActionCreator.getInstance().getVariableGroups();
        LibraryActionCreator.getInstance().getSecureFiles();
        this.updateUrl();
        Navigation_Services.getHistoryService().attachNavigate(this.onUrlChange);
        this._eventManager.attachEvent(Constants.LibraryActions.UpdateErrorMessage, this.updateErrorMessage);
        this._eventManager.attachEvent(Constants.LibraryActions.ClearErrorMessage, this.clearErrorMessage);
        PerfTelemetryManager.instance.endScenario(TelemetryScenarios.LibraryLanding);
    }

    public componentDidUpdate() {
        if (this._isRowDeleted) {
            let tabViewState: LibraryItemsViewState;
            if (this.state && this.state.itemsViewState) {
                tabViewState = this.state.itemsViewState[this.state.selectedTab];
            }

            let numberOfRows: number = (tabViewState && !!tabViewState.data) ? tabViewState.data.length : 0;
            if (numberOfRows > 0) {
                // Focus on next row if it exists
                if (this._lastDeletedRowIndex < numberOfRows) {
                    focusDetailsListRow(this._detailsList, this._lastDeletedRowIndex);
                }
                //Else focus on previous row
                else if (this._lastDeletedRowIndex === numberOfRows) {
                    focusDetailsListRow(this._detailsList, this._lastDeletedRowIndex - 1);
                }
            }
            else if (numberOfRows === 0 && !!this._addVGButton) {
                this._addVGButton.focus();
            }
        }

        this._isRowDeleted = false;
    }

    public componentWillUnmount() {
        this._store.removeChangedListener(this.onStoreChange);
        this._filter.unsubscribe(this._onFilterChanged, FILTER_CHANGE_EVENT);
        this._eventManager.detachEvent(Constants.LibraryActions.UpdateErrorMessage, this.updateErrorMessage);
        this._eventManager.detachEvent(Constants.LibraryActions.ClearErrorMessage, this.clearErrorMessage);

        StoreManager.DeleteStore<LibraryItemsStore>(LibraryItemsStore);
        Navigation_Services.getHistoryService().detachNavigate(this.onUrlChange);
    }

    protected onUrlChange = () => {
        let urlState = Navigation_Services.getHistoryService().getCurrentState();
        let state = this.getState();

        state.selectedTab = LibraryItemType.VariableGroup;
        if (urlState.itemType === Constants.LibraryConstants.LibraryItemsView_SecureFiles) {
            state.selectedTab = LibraryItemType.SecureFile;
        }

        this.setState(state);
    }

    protected getState(): LibraryItemsTabState {
        return this.state;
    }

    private getSearchBoxLabel(): string {
        let labelText = "";
        if (this.state.selectedTab === LibraryItemType.VariableGroup) {
            labelText = Resources.SearchText;
        } else if (this.state.selectedTab === LibraryItemType.SecureFile) {
            labelText = Resources.SearchTextSecureFiles;
        }

        return labelText;
    }

    private _getCommandBarItemsFor(selectedTab: LibraryItemType): IHeaderCommandBarItem[] {
        let items: IHeaderCommandBarItem[] = [];

        if (selectedTab === LibraryItemType.VariableGroup) {
            items.push({
                id: this._addVGKey,
                text: Resources.VariableGroupText,
                important: undefined,
                iconProps: { iconName: "Add", className: "iconColor" },
                onActivate: (menuItem: IMenuItem, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
                    this._onCommandClick(menuItem);
                },
                className: "lib-commandbar-item",
                subtle: true
            });
        }
        else if (selectedTab === LibraryItemType.SecureFile) {
            items.push({
                id: this._uploadSecureFileKey,
                text: Resources.SecureFileText,
                important: undefined,
                iconProps: { iconName: "Add", className: "iconColor" },
                onActivate: (menuItem: IMenuItem, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
                    this._onCommandClick(menuItem);
                },
                className: "lib-commandbar-item",
                subtle: true,

            });
        }

        items.push({
            id: this._securityKey,
            text: Resources.Security,
            important: undefined,
            iconProps: { iconName: "Shield", className: "iconColor" },
            onActivate: (menuItem: IMenuItem, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
                this._onCommandClick(menuItem);
            },
            className: "lib-commandbar-item",
            subtle: true
        });

        items.push({
            id: this._helpKey,
            text: Resources.HelpText,
            important: undefined,
            iconProps: { iconName: "Unknown", className: "iconColor" },
            onActivate: (menuItem: IMenuItem, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
                this._onCommandClick(menuItem);
            },
            className: "lib-commandbar-item",
            subtle: true
        });

        return items;
    }

    private getHubContent(itemType: LibraryItemType): JSX.Element {
        if (itemType === LibraryItemType.VariableGroup) {
            return this.getVariableGroupHubContent();

        } else if (itemType === LibraryItemType.SecureFile) {
            return this.getSecureFileHubContent();
        }
    }

    private getVariableGroupHubContent(): JSX.Element {
        let libraryItems = this._store.getData(LibraryItemType.VariableGroup);
        let learnMoreAboutVariableGroupsHelpText = Utils_String.localeFormat(Resources.LearnMoreAboutVariableGroupsHelpText, Constants.Links.VariableGroupHelpLink);
        if (libraryItems == null) {
            // showing a spinner till the library items are fetched
            return (
                <div className={"lib-spinner"} role="region">
                    <Spinner type={SpinnerType.large} />
                </div>
            );
        } else if (libraryItems.length === 0) {
            return (
                <div className={"lib-intro-page"} role="region" aria-labelledby="lib-intro-page-text">
                    <div className={"lib-intro-page-icon bowtie-icon bowtie-variable-group"}></div>
                    <div className={"lib-intro-page-text"}>{Resources.NewVariableGroupText}</div>
                    <div className={"lib-intro-page-help-text"} dangerouslySetInnerHTML={{ __html: Resources.CreateVariableGroupHelpText }}></div>
                    <div className={"lib-intro-page-button bowtie"}>
                        <button ref={(button) => { this._addVGButton = button; }} onClick={this.createNewVariableGroup} className={"btn-cta"}>
                            <i key={"btn-plus-icon"} className={"bowtie-icon bowtie-math-plus"}></i>
                            <span key={"btn-text"} className="text">{Resources.VariableGroupText}</span>
                        </button>
                    </div>
                    <div>
                        <div className={"lib-intro-help-text"} dangerouslySetInnerHTML={{ __html: learnMoreAboutVariableGroupsHelpText }} />
                        <span className={"bowtie-icon bowtie-navigate-external"} />
                    </div>
                </div>
            );
        } else {
            return (
                <Table
                    columns={this.getColumns(LibraryItemType.VariableGroup)}
                    scrollable={true}
                    itemProvider={this._resourcesProvider}
                    onActivate={this._onActivateRow}
                    role="presentation"
                    ariaLabel={Resources.VariableGroupTableName}
                />
            );
        }
    }

    private getSecureFileHubContent(): JSX.Element {
        let libraryItems = this._store.getData(LibraryItemType.SecureFile);
        let learnMoreAboutSecureFilesHelpText = Utils_String.localeFormat(Resources.LearnMoreAboutSecureFilesHelpText, Constants.Links.SecureFileHelpLink);
        if (libraryItems == null) {
            // showing a spinner till the library items are fetched
            return (
                <div className={"lib-spinner"} role="region">
                    <Spinner type={SpinnerType.large} />
                </div>
            );
        } else if (libraryItems.length === 0) {
            return (
                <div className={"lib-intro-page"} role="region" aria-labelledby="lib-intro-page-text">
                    <div className={"lib-intro-page-icon bowtie-icon bowtie-certificate"}></div>
                    <div className={"lib-intro-page-text"}>{Resources.UploadSecureFileText}</div>
                    <div className={"lib-intro-page-help-text"} dangerouslySetInnerHTML={{ __html: Resources.UploadSecureFileHelpText }}></div>
                    <div className={"lib-intro-page-button bowtie"}>
                        <button onClick={this.uploadNewSecureFile} className={"btn-cta"}>
                            <i key={"btn-plus-icon"} className={"bowtie-icon bowtie-math-plus"}></i>
                            <span key={"btn-text"} className="text">{Resources.SecureFileText}</span>
                        </button>
                    </div>
                    <div>
                        <div className={"lib-intro-help-text"} dangerouslySetInnerHTML={{ __html: learnMoreAboutSecureFilesHelpText }} />
                        <span className={"bowtie-icon bowtie-navigate-external"} />
                    </div>
                </div>
            );
        } else {
            return (
                <Table
                    columns={this.getColumns(LibraryItemType.SecureFile)}
                    scrollable={true}
                    itemProvider={this._resourcesProvider}
                    onActivate={this._onActivateRow}
                    role="presentation"
                    ariaLabel={Resources.SecureFileTableName}
                />
            );
        }
    }

    private createNewVariableGroup = () => {
        Navigation_Services.getHistoryService().addHistoryPoint(undefined, { view: Constants.LibraryConstants.VariableGroupView, variableGroupId: 0 });
    }

    private uploadNewSecureFile = () => {
        Dialogs.Dialogs.showUploadSecureFileDialog();
    }

    private onStoreChange = () => {
        let state = this.getState();
        this._lastDeletedRowIndex = this._store.getLastDeletedRowIndex();
        let itemsViewState = state.itemsViewState.slice();

        let storeData = this._store.getData(state.selectedTab);
        let filteredData = storeData ? storeData.filter(i => i.name.toLowerCase().indexOf(itemsViewState[state.selectedTab].searchValue.toLowerCase()) > -1) : storeData;
        let sortedData = filteredData ? LibraryItemsView.sortItems(filteredData, "name", itemsViewState[state.selectedTab].isSortedDescending) : filteredData;
        itemsViewState[state.selectedTab].data = sortedData;

        state.itemsViewState = itemsViewState;
        if (state.itemsViewState[state.selectedTab].data) {
            this._resourcesProvider = new ArrayItemProvider<LibraryItem>(state.itemsViewState[state.selectedTab].data);
        }
        this.setState(state);
    }

    private getColumns(itemType?: LibraryItemType): ITableColumn<LibraryItem>[] {
        let columns: ITableColumn<LibraryItem>[] = [];
        columns.push(
            {
                id: "name",
                name: Resources.NameText,
                width: new ObservableValue(-30),
                renderHeaderCell: this._renderNameHeaderCell,
                renderCell: this._renderNameCell,
                ariaLabel: Resources.NameText

            });
        columns.push(new ColumnMore(this._menuItems, this._showMenuForItem));
        columns.push(
            {
                id: "dateModified",
                name: Resources.DateModifiedText,
                width: new ObservableValue(-20),
                renderCell: this._renderDateModifiedCell,
                ariaLabel: Resources.DateModifiedText
            });
        columns.push(
            {
                id: "modifiedBy",
                name: Resources.ModifiedByText,
                width: new ObservableValue(-26),
                renderCell: this._renderModifiedByCell,
                ariaLabel: Resources.ModifiedByText
            });
        columns.push(
            {
                id: "description",
                name: Resources.DescriptionText,
                width: new ObservableValue(-24),
                renderCell: this._renderDescriptionCell,
                ariaLabel: Resources.DescriptionText
            });

        return columns;
    }

    private _menuItems = (item: LibraryItem) => {
        this.itemID = item.id;
        const menuItems = new LibraryItemMenu().getMenuItems(item.itemType, item.id, item.name, this.updateShowVariableGroupsDeleteDialogValue, this.updateShowSecureFilesDeleteDialogValue);
        return {
            id: "library-menu",
            items: menuItems
        };
    }

    private _showMenuForItem = (item: LibraryItem) => {
        return true;
    }

    private updateShowVariableGroupsDeleteDialogValue = (value: boolean) => {
        this.setState({ showVariableGroupDeleteDialog: value })
    }

    private updateShowSecureFilesDeleteDialogValue = (value: boolean) => {
        this.setState({ showSecureFileDeleteDialog: value })
    }

    private _renderNameHeaderCell = (columnIndex: number, tableColumn: ITableColumn<LibraryItem>, focuszoneId?: string, isFirstActionableHeader?: boolean): JSX.Element => {
        let iconName = "Ascending";
        if (this.state.itemsViewState[this.state.selectedTab].isSortedDescending) {
            iconName = "Descending";
        }

        return (
            <TableHeaderCell key={"table-header" + columnIndex} column={tableColumn} columnIndex={columnIndex} >
                <div onClick={() => this._onColumnClick(tableColumn.id)} style={{ alignItems: "center", cursor: "pointer" }}>
                    <span >
                        {Resources.NameText}
                    </span>
                    <Icon iconName={iconName} className="sort-icon" />
                </div>
            </TableHeaderCell>
        );

    }

    private _renderNameCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<LibraryItem>, tableItem: LibraryItem): JSX.Element => {
        let sharedBadge;
        if (tableItem.isShared) {
            sharedBadge = (<Tooltip overflowOnly={true} text={Resources.SharedBadgeText}>
                <span className="lib-share-badge">{Resources.SharedBadgeText}</span>
            </Tooltip>);
        }
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex} >
                {
                    this.state.selectedTab === LibraryItemType.VariableGroup &&
                    <Icon iconName="Variable" className="vg-item-name-icon" />
                }
                <Tooltip overflowOnly={true} text={tableItem.name}>
                    <span className="lib-item-var-name">
                        {tableItem.name}
                    </span>
                </Tooltip>
                { tableItem.issue && (
                    <Icon
                        className={tableItem.issue.type === CheckIssueType.Error ? "resource-error-icon" : "resource-warning-icon"}
                        iconName={tableItem.issue.type === CheckIssueType.Error ? "ErrorBadge" : "Warning"}
                        tooltipProps={{
                            text: tableItem.issue.message
                        }}
                    />
                )}
                {sharedBadge}
            </SimpleTableCell>
        );
    }

    private _renderDateModifiedCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<LibraryItem>, tableItem: LibraryItem): JSX.Element => {
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex}>
                <Tooltip overflowOnly={true} text={Utils_Date.friendly(tableItem.modifiedOn)}>
                    <span className="lib-item-list-date" >{Utils_Date.friendly(tableItem.modifiedOn)}</span>
                </Tooltip>
            </SimpleTableCell>
        );
    }

    private _renderModifiedByCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<LibraryItem>, tableItem: LibraryItem): JSX.Element => {
        let imageUrl = Locations.urlHelper.getMvcUrl({
            area: "api",
            controller: "common",
            action: "IdentityImage",
            queryParams: { "id": tableItem.modifiedBy.id },
        });
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex}>
                <img className="lib-item-modifiedby-img" src={imageUrl} alt="" />
                <Tooltip overflowOnly={true} text={tableItem.modifiedBy.displayName}>
                    <span className="lib-item-modifiedby-name">{tableItem.modifiedBy.displayName}</span>
                </Tooltip>
            </SimpleTableCell>
        );
    }

    private _renderDescriptionCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<LibraryItem>, tableItem: LibraryItem): JSX.Element => {
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex}>
                <Tooltip overflowOnly={true} text={tableItem.description}>
                    <span className="lib-item-desc">
                        {tableItem.description}
                    </span>
                </Tooltip>
            </SimpleTableCell>
        );

    }

    private _onActivateRow = (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, row: ITableRow<LibraryItem>) => {
        if (row.data.itemType === LibraryItemType.VariableGroup) {
            Navigation_Services.getHistoryService().addHistoryPoint(undefined, { view: Constants.LibraryConstants.VariableGroupView, variableGroupId: row.data.id });
        } else if (row.data.itemType === LibraryItemType.SecureFile) {
            Navigation_Services.getHistoryService().addHistoryPoint(undefined, { view: Constants.LibraryConstants.SecureFileView, secureFileId: row.data.id });
        }
    }

    private _onColumnClick(tableColumn) {
        this.sortItemsOnClick(tableColumn);
    }

    private _onCommandClick = (item: IMenuItem): void => {
        switch (item.id) {
            case this._addVGKey:
                this.createNewVariableGroup();
                break;

            case this._uploadSecureFileKey:
                this.uploadNewSecureFile();
                break;

            case this._securityKey:
                Dialogs.Dialogs.showSecurityDialog(LibraryItemType.Library);
                break;

            case this._helpKey:
                this.openLibraryItemHelpWindow();
                break;

            default:
                break;
        }
    }

    private static sortItems(data: LibraryItem[], sortOnElement: string, isSortedDescending: boolean): LibraryItem[] {
        let sortedItems = data.sort((a, b) => {
            let firstValue, secondValue;
            if (sortOnElement === "name") {
                firstValue = a.name.toLowerCase();
                secondValue = b.name.toLowerCase();
            }
            const compareField = Utils_String.localeComparer(firstValue, secondValue);
            return ((isSortedDescending) ? -compareField : compareField);
        });

        return sortedItems;
    }

    private sortItemsOnClick(sortOnElement: string): void {
        if (sortOnElement === "name") {
            let state = this.getState();
            let newSortOrder = !state.itemsViewState[state.selectedTab].isSortedDescending;
            let data = state.itemsViewState[this.state.selectedTab].data;
            let sortOrderText = newSortOrder ? Resources.NameSortedDescending : Resources.NameSortedAscending;
            announce(sortOrderText);
            let sortedItems = data ? LibraryItemsView.sortItems(data, sortOnElement, newSortOrder) : data;

            let itemsViewState = state.itemsViewState.slice();
            itemsViewState[state.selectedTab].data = sortedItems;
            itemsViewState[state.selectedTab].isSortedDescending = newSortOrder;
            state.itemsViewState = itemsViewState;
            if (state.itemsViewState[state.selectedTab].data) {
                this._resourcesProvider = new ArrayItemProvider<LibraryItem>(state.itemsViewState[state.selectedTab].data);
            }
            this.setState(state);
        }
    }

    private _onFilterChanged = (changedState: IFilterState) => {
        const filter = this._filter.getState()
        const keywordProp = filter[this._nameFilterKey];
        const filterKeywords = keywordProp ? keywordProp.value : "";
        if (filterKeywords != null && filterKeywords !== undefined) {
            this.searchLibraryItems(filterKeywords);
        }
    }

    private searchLibraryItems = (searchValue: string): void => {
        let state = this.getState();
        let data = this._store.getData(state.selectedTab);
        let filteredData = data ? data.filter(i => i.name.toLowerCase().indexOf(searchValue.toLowerCase()) > -1) : data;
        let sortedData = filteredData ? LibraryItemsView.sortItems(filteredData, "name", state.itemsViewState[state.selectedTab].isSortedDescending) : filteredData;

        let itemsViewState = state.itemsViewState.slice();
        itemsViewState[state.selectedTab].searchValue = searchValue;
        itemsViewState[state.selectedTab].data = sortedData;
        state.itemsViewState = itemsViewState;
        announce(Utils_String.localeFormat(Resources.SearchResultsMessage, itemsViewState[state.selectedTab].data.length));
        if (state.itemsViewState[state.selectedTab].data) {
            this._resourcesProvider = new ArrayItemProvider<LibraryItem>(state.itemsViewState[state.selectedTab].data);
        }

        this.setState(state);
    }

    private newLibraryItemButton = (): JSX.Element => {
        if (this.state.selectedTab === LibraryItemType.VariableGroup) {
            return (
                <div className={"lib-new-button bowtie"}>
                    <button className={"btn-cta"} onClick={this.createNewVariableGroup} aria-label={Resources.NewVariableGroupButtonName}>
                        <i key={"btn-plus-icon"} className={"bowtie-icon bowtie-math-plus"}></i>
                        <span key={"btn-text"} className="text">{Resources.VariableGroupText}</span>
                    </button>
                </div>);
        } else if (this.state.selectedTab === LibraryItemType.SecureFile) {
            return (
                <div className={"lib-new-button bowtie"}>
                    <button className={"btn-cta"} onClick={this.uploadNewSecureFile} >
                        <i key={"btn-plus-icon"} className={"bowtie-icon bowtie-math-plus"}></i>
                        <span key={"btn-text"} className="text">{Resources.SecureFileText}</span>
                    </button>
                </div>);
        }
    };

    private openLibraryItemHelpWindow = () => {
        if (this.state.selectedTab === LibraryItemType.VariableGroup) {
            window.open(Constants.Links.VariableGroupHelpLink, "_blank");
        } else if (this.state.selectedTab === LibraryItemType.SecureFile) {
            window.open(Constants.Links.SecureFileHelpLink, "_blank");
        }
    }

    private updateErrorMessage = (sender: any, error: any) => {
        let state = this.state;
        let itemsViewState = state.itemsViewState.slice();
        itemsViewState[state.selectedTab].errorMessage = Utils_String.htmlEncode(VSS.getErrorMessage(error));
        this.setState({ itemsViewState });
    }

    private clearErrorMessage = () => {
        let state = this.state;
        let itemsViewState = state.itemsViewState.slice();
        itemsViewState[state.selectedTab].errorMessage = "";
        this.setState({ itemsViewState });
    }

    private _store: LibraryItemsStore;
    private _eventManager: Events_Services.EventService;
    private _detailsList: HTMLElement;
    private _addVGButton: HTMLElement;
    private _isRowDeleted: boolean = false;
    private _lastDeletedRowIndex: number = -1;

    private readonly _nameFilterKey = "nameFilterKey";
    private readonly _helpKey = "helpKey";
    private readonly _securityKey = "securityKey";
    private readonly _addVGKey = "addVGKey";;
    private readonly _uploadSecureFileKey = "uploadSecureFile";
    private readonly _variableGroupsKey = "variableGroupsKey";
    private readonly _secureFilesKey = "secureFilesKey";
    private readonly _libraryKey = "libraryKey";
    private selectedTabId = "";
    private _filter: Filter;
    private _resourcesProvider: ArrayItemProvider<LibraryItem>;
    private itemID: string;
}
